module.exports = __webpack_public_path__ + "static/media/comment-alt-smile.ee088b9c.svg";